export default __webpack_public_path__ + "static/media/flag.307fea0d.svg";